import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import PrivacyPolicy from './privacy-policy';
import AboutUs from './about-us';
import TermsConditions from './terms-condition';
import { PageLink, PageTitle } from '../../../_uLearn/layout/core';
const profileBreadCrumbs: Array<PageLink> = [
  {
    title: 'Profile',
    path: '/cms-pages',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const CmsPages = () => {
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
        <Route
          path="about-us"
          element={
            <>
              <PageTitle breadcrumbs={profileBreadCrumbs}>About Us</PageTitle>
              <AboutUs />
            </>
          }
        />
        <Route
          path="privacy-policy"
          element={
            <>
              <PageTitle breadcrumbs={profileBreadCrumbs}>
                Privacy Policy
              </PageTitle>
              <PrivacyPolicy />
            </>
          }
        />
        <Route
          path="terms-conditions"
          element={
            <>
              <PageTitle breadcrumbs={profileBreadCrumbs}>
                Terms and Conditions
              </PageTitle>
              <TermsConditions />
            </>
          }
        />
      </Route>
    </Routes>
  );
};
export default CmsPages;
